export default function ScorePrice({price, currency}) {
    return (
        <span className={"score score-" + currency.code}>{price}<span>{currency.name}</span></span>
    );
}
